import React from 'react';
import { Link } from 'react-router-dom';
import useInheritParams from 'hooks/useInheritParams';
import useBusinessParam from 'hooks/useBusiness';
import { SamplePageNameEn } from 'lib/FL';
import styles from './BusinessSwitch.module.scss';

type BusinessData = {
  nameEn: SamplePageNameEn;
  nameJa: string;
};
const businessesData: BusinessData[] = [
  { nameEn: 'index', nameJa: '不動産' },
  { nameEn: 'construction', nameJa: '建築' },
  { nameEn: 'reform', nameJa: 'リフォーム' },
];

const BusinessSwitch: React.FC = () => {
  const business = useBusinessParam();
  const { inheritParams } = useInheritParams();

  return (
    <ul className={styles.businessSwitch}>
      {businessesData.map((businessData) => (
        <li key={businessData.nameEn}>
          <Link
            to={{
              pathname: `/designs/${businessData.nameEn}`,
              search: inheritParams,
            }}
            className={`${styles.business__link} ${
              businessData.nameEn === business ? styles.business__link_active : ''
            }`}
          >
            {businessData.nameJa}
          </Link>
        </li>
      ))}
    </ul>
  );
};

export default BusinessSwitch;
